import { Routes } from '@angular/router';
import { registerSuccessRoute, registerRoute } from './register/register.route';
import { fcAuthRedirectRoute } from './fc-auth-redirect/fc-auth-redirect.route';
import { activateAccountRoute, activateEmailRoute } from './activate/activate.route';
import { monCompteRoute, settingsRoute } from './settings/settings.route';
import { passwordResetFinishRoute } from './password-reset/finish/password-reset-finish.route';
import { passwordResetInitRoute } from './password-reset/init/password-reset-init.route';
import { authenticationRoute } from './authentication/authentication.route';

let ACCOUNT_ROUTES = [
    activateEmailRoute,
    monCompteRoute,
    passwordResetFinishRoute,
    passwordResetInitRoute,
    registerRoute,
    registerSuccessRoute,
    settingsRoute,
    authenticationRoute,
    fcAuthRedirectRoute
];

export const accountState: Routes = ACCOUNT_ROUTES.concat(activateAccountRoute);



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/account.route.ts